
import { ASSET_DOMAIN } from "../common/config-local";

export default {
    url(url) {
        return ASSET_DOMAIN + url;
    },
    meeroThumbnail(albumId, id) {
        return ASSET_DOMAIN + "/api/album/" + albumId + "/thumbnail/" + id
    },
    meeroOriginal(albumId, id) {
        return ASSET_DOMAIN + "/api/album/" + albumId + "/original/" + id
    }
}